import { Modal } from 'react-bootstrap';
import { OptimizationFailureDetails } from '@Components/OptimizationFailureDetails/OptimizationFailureDetails';
import { LogsTarget } from './logs-modal-constants';
import { buildLogsLinks } from './logs-modal-utils';

interface LogsModalProps {
  target: LogsTarget;
  company: string;
  onHide: () => void;
}

export const LogsModal = ({ target, company, onHide }: LogsModalProps) => (
  <Modal size='lg' centered show onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Details for Run #{target.buildNumber}</Modal.Title>
    </Modal.Header>
    <Modal.Body className='optimization-log-links'>
      <OptimizationFailureDetails
        target={{
          type: 'linear',
          company,
          kpi: target.kpi,
          runId: target.buildNumber,
          status: target.status
        }}
      />
      {buildLogsLinks(target).map(link => (
        <a key={link.label} href={link.href} target='_blank' rel='noopener noreferrer'>
          {link.label}
        </a>
      ))}
    </Modal.Body>
  </Modal>
);
